import { render, staticRenderFns } from "./blogDataUpdate.vue?vue&type=template&id=70f9532e&"
import script from "./blogDataUpdate.vue?vue&type=script&lang=js&"
export * from "./blogDataUpdate.vue?vue&type=script&lang=js&"
import style0 from "./blogDataUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports